import React, { useEffect, useState } from 'react'

function CheckList({ data, checkedItems, onCheckboxChange, groupName }) {
    return (
      <div>
        <ul className='lyt-check-list'>
          <li className='lyt-check-list__item'>
            {data.map((item, index) => {
              const safeId = item?.replace(/\s+/g, '-')?.toLowerCase()+'-'+groupName;
            return (
              <div className='bs-checkbox' key={index}>
                <input
                  type="checkbox"
                  id={safeId}
                  name={item}
                  value={item}
                  checked={checkedItems[item] || false}
                  onChange={() => onCheckboxChange(item)}
                />
                <label className="bs-checkbox__label" htmlFor={safeId}>{item}</label>
              </div>
            )})}
          </li>
        </ul>
      </div>
    );
}

export default CheckList